// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".images[data-v-a182050a] {\n  position: absolute;\n  width: 54px;\n  height: 27px;\n  left: 3px;\n}\n[data-v-a182050a] .el-image__inner {\n  opacity: 0;\n}\n.detail-centent[data-v-a182050a] {\n  line-height: 30px;\n  font-size: 14px;\n}\n.textE93323[data-v-a182050a] {\n  color: #e93323;\n}\n.detail-title[data-v-a182050a] {\n  font-size: 16px;\n}\n[data-v-a182050a] .el-icon-circle-close {\n  color: #999;\n}", ""]);
// Exports
module.exports = exports;
